import Image from 'next/image';

import styles from '@/components/agents/agents.module.css';

import clsxm from '@/lib/clsxm';

import { delay, SectionHeading } from '@/components/agents/primitives';
import { useReveal } from '@/components/agents/useReveal';

import { PERSONAS } from './kit';

export default function WorkshopsAudience() {
  const { ref, state } = useReveal<HTMLUListElement>(0.1);

  return (
    <section className='pb-24 sm:pb-32'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <SectionHeading
          title='Who it’s for.'
          tail='Anyone with more work than hours.'
          lead='If you make content, sell, or run a team, you leave with tools you can use the same day.'
        />
      </div>

      {/* Phones scroll the cards sideways; larger screens show a grid. */}
      <ul
        ref={ref}
        data-reveal={state}
        className={clsxm(
          styles.reveal,
          'mt-14 flex snap-x snap-mandatory gap-4 overflow-x-auto px-6 pb-4 [scrollbar-width:none] sm:mx-auto sm:grid sm:max-w-7xl sm:grid-cols-2 sm:overflow-visible sm:pb-0 lg:grid-cols-3 lg:px-8 [&::-webkit-scrollbar]:hidden',
        )}
      >
        {PERSONAS.map(({ title, text, image }, index) => (
          <li
            key={title}
            className={clsxm(
              styles.rv,
              'relative aspect-[4/5] w-[78%] flex-none snap-start overflow-hidden rounded-[24px] bg-[#e8e8f0] sm:w-auto lg:aspect-square dark:bg-white/5',
            )}
            style={delay(index * 70)}
          >
            <Image
              src={image}
              alt=''
              fill
              unoptimized
              className='object-cover object-[50%_30%]'
            />
            <div className='absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0d0c1f]/90 via-[#0d0c1f]/55 to-transparent px-6 pb-6 pt-24'>
              <h3 className='text-xl font-semibold tracking-[-0.015em] text-white'>
                {title}
              </h3>
              <p className='mt-1.5 text-[15px] leading-6 text-white/80'>
                {text}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
